import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'
import layout from '../../tokens/layout'

export const Wrapper = styled.div.attrs((props) => composeTheme(props))`
  font-family: ${fonts.inter};
  font-size: 1.4rem;
  line-height: 2.1rem;
  font-weight: 400;
  display: flex;
  color: ${colors.neutralColorLowPure};
  align-items: center;
  position: relative;

  &.is-disabled {
    color: ${colors.neutralColorLowMedium};
  }

  .container-icon {
    position: absolute;
    pointer-events: none;
    left: 0.1rem;
  }

  &.selected {
    .MuiSvgIcon-root {
      width: 2.5rem;
      color: ${(props) => props.theme.checkbox.selectedColor};
    }
  }

  &.indeterminate {
    .MuiSvgIcon-root {
      width: 2.5rem;
      color: ${colors.neutralColorHighPure};
    }
  }

  &.preselected {
    .MuiSvgIcon-root {
      width: 2.5rem;
      color: ${(props) => props.theme.brandColors.primaryPure};
    }
    &.is-disabled {
      .MuiSvgIcon-root {
        color: ${colors.neutralColorLowLight};
      }
    }
  }
`

export const Box = styled.input.attrs((props) => composeTheme(props))`
  display: flex;
  width: 2.4rem;
  height: 2.4rem;
  cursor: pointer;
  margin: ${layout.margin.spacingNone};
  margin-right: ${(props) => props.theme.checkbox.marginRight};
  border-radius: ${(props) => props.theme.checkbox.borderRadius};
  box-sizing: border-box;
  appearance: none;

  &.unselected {
    border: ${(props) => props.theme.checkbox.borderWidth} solid
      ${(props) => props.theme.checkbox.borderColor};
    background-color: ${(props) => props.theme.checkbox.background};

    &.is-disabled {
      border-color: ${colors.neutralColorHighMedium};
      background-color: ${colors.neutralColorHighLight};
    }
  }

  &.negative {
    border: solid 0.2rem ${colors.feedbackColorNegativePure};

    &.is-disabled {
      background-color: ${colors.neutralColorHighLight};
      border-color: ${colors.neutralColorHighMedium};
      color: ${colors.neutralColorLowLight};
    }
  }

  &.selected {
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    border: ${(props) => props.theme.checkbox.borderWidth} solid
      ${(props) => props.theme.checkbox.borderColorSelected};
    background-color: ${(props) =>
      props.theme.checkbox.backgroundSelected ||
      props.theme.brandColors.primaryPure};

    &.is-disabled {
      background-color: ${colors.neutralColorLowLight};
      border-color: ${colors.neutralColorLowLight};
      color: ${colors.neutralColorLowLight};
    }
  }

  &.indeterminate {
    background-color: ${(props) => props.theme.brandColors.primaryPure};
    &.is-disabled {
      background-color: ${colors.neutralColorLowLight};
      border-color: ${colors.neutralColorLowLight};
      color: ${colors.neutralColorLowLight};
    }
  }

  &.preselected {
    border: none;
    pointer-events: none;
    cursor: not-allowed;
  }

  &.is-disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
`
Box.defaultProps = defaultTheme

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(7, 1fr);
  grid-column-gap: 0;
  grid-row-gap: 0.3rem;

  .div1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .div2 {
    grid-area: 1 / 2 / 2 / 3;
  }
`

export const Text = styled.p`
  color: #00c2ff;
  font-family: ${fonts.inter};
  font-size: 1.6rem;
  font-style: normal;
  font-weight: normal;
  line-height: 2.4rem;
  text-transform: uppercase;
`

export const ContainerIcon = styled.div``
